export const REPORT_CALENDAR_REPORT_DETAILS_DRAWER = {
	width: 480,
	fillReturnLabel: 'Fill Return',
	viewReturnLabel: 'View Return',
}
